import {makeAutoObservable} from "mobx";
import PresetInterface from "../interfaces/PresetInterface";
import axios from "axios";

class ItemsStore {

    Preset: PresetInterface|null = null
    loading_state: boolean = false

    isScore: boolean = false

    constructor() {
        makeAutoObservable(this)
    }

    turnLoading (state: boolean) {
        this.loading_state = state
    }

    setIsScore (state: boolean) {
        this.isScore = state
    }

    async loadPreset(lead_id: number, preset_id: string) {
        this.turnLoading(true)

        try {
            this.Preset = (await axios.get(`https://products.amo.tools/table/api/${preset_id}/${lead_id}`)).data
        } catch (e) {
            console.trace(e)
        }

        this.turnLoading(false)
    }

    addStylesHTML(styles: string) {

        const $head = document.querySelector("head") as HTMLHeadElement
        const $styles = document.createElement("style")
        $styles.innerHTML = styles
        $head.append($styles)
    }

    async loadScore(score_id: string) {
        this.turnLoading(true)

        try {
            this.Preset = (await axios.get(`https://products.amo.tools/table/api/${score_id}`)).data
        } catch (e) {
            console.trace(e)
        }

        this.turnLoading(false)
    }

}

export default new ItemsStore()